import React from 'react';
import clx from 'classnames';

import { getCurrencyFormat } from '@helpers/formats';
import { getDateFormat, getTimeFormat } from '@helpers/datetime';
import { AuctionBiddingMethod, AuctionResponse, AuctionWinnerResponse } from '@types';

interface Props {
  winner?: AuctionWinnerResponse;
  auction: AuctionResponse;
  className?: string;
}

const AuctionEndedInfo: React.FC<Props> = (props) => {
  if (props.auction.parentStatus !== 'ended' && props.auction.parentStatus !== 'overcharge') {
    return null;
  }

  return (
    <div className={clx(['component-auction-ended-info', props.className])}>
      <h2 className="block-title">
        {props.winner?.winnerBid?.drawNumber
          ? props.auction.translations?.auction_result_draw || 'auction_result_draw'
          : props.auction.translations?.auction_result || 'auction_result'}
      </h2>
      <div className="ended-info">
        {props.auction.translations?.auction_result_end_dt || 'auction_result_end_dt'}{' '}
        {getDateFormat(props.auction.realEndDt || props.auction.endDt)} v{' '}
        {getTimeFormat(props.auction.realEndDt || props.auction.endDt)}
      </div>

      {props.auction.biddingMethod === AuctionBiddingMethod.holland ? (
        <>
          {props.winner?.winnerBid && (
            <>
              <div className="ended-info-subtitle">V uvedeném okamžiku akceptoval aktuální cenu účastník označený jako:
                Dražitel č. {props.winner?.winnerBid?.userAuction.uniqueCode}
              </div>
              <div className="ended-info-subtitle"> Předmět dražby byl vydražen za
                cenu: {getCurrencyFormat(props.winner?.winnerBid?.bidPrice)}</div>
              <div className="ended-info-subtitle"> Tímto byla dražba ukončena a další úkony účastníků nejsou možné.
              </div>
            </>
          )}
        </>
      ) : (
        <>
          {props.auction.auctionType === 'public_competition' ? (
            <div className="ended-info-subtitle">V tuto chvíli není možné činit další nabídky.</div>

          ) : (
            <div className="ended-info-subtitle">V tuto chvíli není možné činit další podání.</div>
          )}

          {
            !!props.winner?.winnerBid && (
              <div className="bids-info">
                <div className="bid-item">
                  {props.winner?.winnerBid?.userAuction.preEmption ||
                  props.winner?.winnerBid?.userAuction.ownershipPreEmption ? (
                    <>
                      <span>Příklep byl z důvodu předkupního práva učiněn dražiteli č.:</span>{' '}
                      {props.winner.winnerBid?.userAuction.uniqueCode}
                    </>
                  ) : (
                    <>
                      <span>{props.auction.auctionType === 'public_competition' ? 'Nejvyšší nabídku učinil:' : 'Nejvyšší podání učinil:'}</span> {props.auction.auctionType === 'public_competition' ? 'Navrhovatel' : 'Dražitel'} č.{props.winner.winnerBid?.userAuction.uniqueCode}
                    </>
                  )}
                </div>
                <div className="bid-item">
                  <span>{props.auction.auctionType === 'public_competition' ? 'Nejvyšší nabídková cena učiněna ve výši:' : 'Nejvyšší podání učiněno ve výši:'}</span> {getCurrencyFormat(props.winner.winnerBid.bidPrice)}
                </div>
              </div>
            )
          }
        </>
      )
      }
    </div>
  )
    ;
};

export default AuctionEndedInfo;
